import { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../security/hooks/axiosProvider';
import styles from '../../../styles/style-setting.module.scss';

const CreateNatureCharge = (props) => {
  const httpClient = useHttpClient(true);
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm();
  const [CreateUnitModal, setCreateUnitModal] = useState(false);
  const [Open, setOpen] = useState(false);
  const [activities, setActivities] = useState([]);
  const CreateModalToggle = () => resetForm();
  const Toggle = () => setOpen(!Open);
  const history = useHistory();
  const [spinner, setSpinner] = useState(false);

  const onSubmit = async (data) => {
    const chargeData = {
      name: data['charge_name'],
      description: data['charge_description'],
      activity: JSON.parse(data['charge_activity']),
    };
    try {
      setSpinner(true);
      const response = httpClient.current?.post(`/api/naturecharge`, chargeData);
      if ((await response).status === 200) {
        setSpinner(false);
        props.charges();
        resetForm();
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    resetField('charge_name');
    resetField('charge_activity');
    resetField('charge_description');
    setCreateUnitModal(!CreateUnitModal);
  };

  useEffect(() => {
    const getActivities = () => {
      httpClient.current?.get(`/api/activity/all`).then((response) => {
        setActivities(response.data);
      });
    };
    getActivities();
  }, [httpClient]);

  return (
    <>
      <Button outline color="success" onClick={CreateModalToggle}>
        {' '}
        {props.t('create_activity_charge')}
      </Button>
      <Modal isOpen={CreateUnitModal} toggle={CreateModalToggle} centered>
        <ModalHeader toggle={CreateModalToggle}>{props.t('create_activity_charge')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={Open} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            {activities.length <= 0 ? (
              <div className="text-center">
                <Button outline color="danger" onClick={() => history.push('/settings/activity')}>
                  {props.t('msg_enter_activity')}
                </Button>
              </div>
            ) : spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <FormGroup className="form-row">
                  <label htmlFor="charge_name">{props.t('charge_name')}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="charge_name"
                    id="charge_name"
                    aria-invalid={errors.charge_name ? 'true' : 'false'}
                    placeholder={props.t('enter_charge_name')}
                    {...register('charge_name', { required: true })}
                  />
                  <span>{errors.charge_name && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor="charge_description">{props.t('Description')}</label>
                  <textarea
                    className="form-control"
                    name="charge_description"
                    {...register('charge_description')}
                    id="unit_description"
                    rows={3}
                    placeholder={props.t('more_details')}
                  ></textarea>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'charge_activity'}>{props.t('charge_activity_name')}</label>
                  <select
                    name="charge_activity"
                    id="charge_activity"
                    className="form-control"
                    {...register('charge_activity')}
                  >
                    {activities.map((activity, index) => (
                      <option id={activity.id} key={index} value={JSON.stringify(activity)}>
                        {activity.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('save')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={resetForm}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CreateNatureCharge);
